/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
if (typeof $("body").owlCarousel == "function") {
  $(" .owl-arrival__slider").owlCarousel({
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    loop: true,
    nav: true,
    margin: 10,
    smartSpeed: 600,
    responsive: {
      0: {
        items: 1.5,
        margin: 10,
      },
      375: {
        items: 1.5,
      },
      425: {
        items: 2,
      },
      571: {
        items: 2.5,
      },
      768: {
        items: 3,
      },
      991: {
        items: 3,
      },
      1024: {
        items: 4,
        margin: 30,
      },
    },
  });

  $(" .owl-carousel-recommend").owlCarousel({
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    loop: true,
    nav: true,
    margin: 10,
    responsive: {
      0: {
        items: 1.5,
        margin: 10,
      },
      375: {
        items: 1.5,
      },
      425: {
        items: 2,
      },
      571: {
        items: 2.5,
      },
      768: {
        items: 3,
      },
      991: {
        items: 3,
      },
      1024: {
        items: 4,
        margin: 30,
      },
    },
  });

  var $owl1 = $(".odul-monthly-slider");

  $owl1.each(function () {
    var $owl = $(this);
    $owl.children().each(function (index) {
      $(this).attr("data-position", index);
    });

    $owl.owlCarousel({
      loop: false,
      nav: true,
      items: 1,
      margin: 10,
    });

    $owl
      .closest(".block-animal")
      .find(".button-love")
      .on("click", function () {
        var $speed = 300;
        $owl.trigger("to.owl.carousel", [1, $speed]);
      });
    $owl
      .closest(".block-animal")
      .find(".button-money")
      .on("click", function () {
        var $speed = 300;
        $owl.trigger("to.owl.carousel", [2, $speed]);
      });
    $owl
      .closest(".block-animal")
      .find(".button-work")
      .on("click", function () {
        var $speed = 300;
        $owl.trigger("to.owl.carousel", [3, $speed]);
      });
  });
}
$(".drawer__hiden").click(function () {
  $(".header__drawer").removeClass("drawer--visible");
  $("html").removeAttr("data-scroll-locked");
  // $("body").css("overflow": 'auto');
});

// $(".collection__btn-show").click(function () {
//   var gf__closebtn =
//     '<div class="gf__closeBtn gf-show"><span class="gf_text__closeBtn">x</span><div>';
//   if (
//     !$(document).find(".collection__products").find("div.gf__closeBtn").length
//   ) {
//     $(document).find(".collection__products").prepend(gf__closebtn);
//   }
//   $(".gf__closeBtn").addClass("gf-show");
//   $("#gf-tree").addClass("gf-show");
//   $(".gf-controls-search-form").addClass("gf-show");
// });

$(".collection__item-sort").click(function (e) {
  $(this).toggleClass("active");
  $(".filter_select").toggleClass("opened");
  e.stopPropagation();
});
$(window).click(function () {
  $(".filter_select").removeClass("opened");
});
$(document).on("click", "span.gf_text__closeBtn", function () {
  $(".gf__closeBtn").removeClass("gf-show");
  $("#gf-tree").removeClass("gf-show");
  $(".gf-controls-search-form").removeClass("gf-show");
});

var formObjInterval = setInterval(function () {
  if ($(document).find(".globo-selected-items-wrapper").text().trim()) {
    var form =
      '<div class="gf-block-content"><form class="gf-controls-search-form">';
    form += $(document)
      .find("#gf-controls-container")
      .find(".gf-controls-search-form")
      .html();
    form += "</form><div>";

    if (
      !$(document)
        .find("#gf-tree")
        .find(".globo-selected-items-wrapper")
        .find(".gf-controls-search-form").length
    ) {
      $(document)
        .find("#gf-tree")
        .find(".globo-selected-items-wrapper")
        .append(form);
      $(document)
        .find("#gf-controls-container")
        .find(".gf-controls-search-form")
        .removeClass("gf-show");
      $(document)
        .find("#gf-tree")
        .find(".gf-controls-search-form")
        .addClass("gf-show");
      $(document).find("#gf-tree").css("top", "225px");
    }
  } else {
    $(document).find("#gf-tree").css("top", "285px");
  }
}, 30);
setTimeout(function () {
  $(document).on("click", ".gf-block-title a", function () {
    $(document)
      .find("#gf-controls-container")
      .find(".gf-controls-search-form")
      .addClass("gf-show");
  });

  $(document).on("click", ".selected-item a", function () {
    if ($(document).find("div.selected-item a").length == 1) {
      $(document)
        .find("#gf-controls-container")
        .find(".gf-controls-search-form")
        .addClass("gf-show");
    }
  });
}, 500);

// Scroll active image
$(".gallery-thumb-item").on("click", function (e) {
  e.preventDefault();
  var image_id = $(this).attr("data-image-id");
  $("html,body").animate(
    {
      scrollTop: $("#" + image_id).offset().top - 25,
    },
    0
  );
});
if ($(".product-gallery-slider-sp").length) {
  $(".product-gallery-slider-sp").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.01823 0.381997C8.19396 0.557733 8.19396 0.842657 8.01823 1.01839L1.71823 7.31839C1.54249 7.49413 1.25757 7.49413 1.08183 7.31839C0.906095 7.14266 0.906095 6.85773 1.08183 6.682L7.38183 0.381997C7.55757 0.206261 7.84249 0.206261 8.01823 0.381997Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.01821 13.6183C7.84247 13.7941 7.55755 13.7941 7.38181 13.6183L1.08182 7.31833C0.90608 7.14259 0.90608 6.85767 1.08182 6.68193C1.25755 6.50619 1.54248 6.50619 1.71821 6.68193L8.01821 12.9819C8.19395 13.1577 8.19395 13.4426 8.01821 13.6183Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.981803 13.618C0.806067 13.4423 0.806067 13.1573 0.981803 12.9816L7.2818 6.68161C7.45754 6.50587 7.74246 6.50587 7.9182 6.68161C8.09394 6.85734 8.09394 7.14227 7.9182 7.318L1.6182 13.618C1.44246 13.7937 1.15754 13.7937 0.981803 13.618Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.981805 0.381675C1.15754 0.205939 1.44247 0.205939 1.6182 0.381675L7.9182 6.68167C8.09394 6.85741 8.09394 7.14233 7.9182 7.31807C7.74246 7.49381 7.45754 7.49381 7.2818 7.31807L0.981805 1.01807C0.806069 0.842335 0.806069 0.55741 0.981805 0.381675Z" fill="black"/></svg></button>',
  });
}

function check_thumb_active() {
  var scroll_top = $(window).scrollTop() + 300;
  if ($(".product-gallery-large .product__photo").length) {
    $(".product-gallery-large .product__photo").each(function () {
      var image_id = $(this).attr("data-id");
      var offset_top = $(this).offset().top;
      var offset_bottom = $(this).offset().top + $(this).height();
      if (offset_top <= scroll_top && offset_bottom >= scroll_top) {
        $("." + image_id).addClass("active");
      } else {
        $("." + image_id).removeClass("active");
      }
    });
  }
}
check_thumb_active();
$(window).on("scroll", function () {
  check_thumb_active();
});

function getQueryParams(qs) {
  qs = qs.split("+").join(" ");

  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

function detect_param(key, value, active = 0) {
  if (active) {
    var location_search = decodeURI(window.location.search).replace(
      "&" + key + "=" + value,
      ""
    );
    location_search = location_search.replace(
      "?" + key + "=" + value + "&",
      "?"
    );
    location_search = location_search.replace("?" + key + "=" + value, "");
    location_search = location_search.replace(key + "=" + value, "");
    window.location =
      window.location.origin + window.location.pathname + location_search;
    return;
  }
  var paramObj = getQueryParams(window.location.search);
  if (new URLSearchParams(window.location.search).get(key)) {
    var list_params = Object.entries(paramObj);
    var param = "";
    for (let i in list_params) {
      if (list_params[i][0] == key) {
        list_params[i][1] = value;
      }
      if (i == 0) {
        param += "?" + list_params[i].join("=");
      } else {
        param += "&" + list_params[i].join("=");
      }
    }
  } else {
    if (window.location.search) {
      var param = window.location.href + "&" + key + "=" + value;
    } else {
      var param = window.location.href + "?" + key + "=" + value;
    }
  }
  window.location = param;
}

function detect_param_price(price_param) {
  var param_search = window.location.search;
  var paramObj = getQueryParams(param_search);
  var params = "";
  for (let j in price_param) {
    key = price_param[j].key;
    value = price_param[j].value;
    if (new URLSearchParams(param_search).get(key)) {
      var list_params = Object.entries(paramObj);
      var param = "";
      for (let i in list_params) {
        if (list_params[i][0] == key) {
          list_params[i][1] = value;
        }
        if (i == 0) {
          param += "?" + list_params[i].join("=");
        } else {
          param += "&" + list_params[i].join("=");
        }
      }
      if (j == 1) {
        param_search = param.replace(
          price_param[0].key +
            "=" +
            new URLSearchParams(window.location.search).get(
              "filter.v.price.gte"
            ),
          price_param[0].key + "=" + price_param[0].value
        );
      } else {
        param_search = param;
      }
    } else {
      if (param_search) {
        param_search += "&" + key + "=" + value;
      } else {
        param_search += "?" + key + "=" + value;
      }
    }
  }
  window.location =
    window.location.origin + window.location.pathname + param_search;
}

function collectionSort(filter) {
  detect_param("sort_by", filter);
}

function checkLayoutMode(layout_count) {
  if (!layout_count) {
    layout_count = 2;
  }
  $(".collection__products").attr("data-mode", layout_count);
  $(".change-layout-mode").removeClass("is-active");
  $(".change-layout-mode[data-count=" + layout_count + "]").addClass(
    "is-active"
  );
  setCookie("collection_layout_mode", layout_count, 7);
}

var layoutCount = getCookie("collection_layout_mode");
checkLayoutMode(layoutCount);

$(".change-layout-mode").on("click", function () {
  var layout_count = $(this).attr("data-count");
  checkLayoutMode(layout_count);
});

$(".odul-filter-button").click(function () {
  var min_price = $("#one").val();
  var key_min_price = $("#one").attr("data-name");
  var key_max_price = $("#two").attr("data-name");
  var max_price = $("#two").val();
  var data = [
    { key: key_min_price, value: min_price },
    { key: key_max_price, value: max_price },
  ];
  detect_param_price(data);
});

$(function () {
  $(".odul-menu-filter-overlay").click(function () {
    $(".odul-menu-filter").removeClass("open");
    $(".odul-menu-filter-overlay").removeClass("odul-is-visible");
    $("html").removeClass("no-scroll");
  });

  $(".menu-click").click(function () {
    $(".odul-menu-filter").toggleClass("open");
    $(".odul-menu-filter-overlay").toggleClass("odul-is-visible");
    $("html").toggleClass("no-scroll");
  });
  $("body").on("swipeleft", function () {
    $(".odul-menu-filter").addClass("open");
    $(".odul-menu-filter-overlay").removeClass("odul-is-visible");
    $("html").removeClass("no-scroll");
  });
  $(".menu").on("swiperight", function () {
    $(".odul-menu-filter").toggleClass("open");
    $(".odul-menu-filter-overlay").addClass("odul-is-visible");
    $("html").addClass("no-scroll");
  });

  if ($("#lower").length) {
    var lowerSlider = document.querySelector("#lower");
    var upperSlider = document.querySelector("#upper");

    document.querySelector("#two").value = upperSlider.value;
    document.querySelector("#one").value = lowerSlider.value;

    var lowerVal = parseInt(lowerSlider.value);
    var upperVal = parseInt(upperSlider.value);

    upperSlider.oninput = function () {
      lowerVal = parseInt(lowerSlider.value);
      upperVal = parseInt(upperSlider.value);

      if (upperVal < lowerVal + 4) {
        lowerSlider.value = upperVal - 4;
        if (lowerVal == lowerSlider.min) {
          upperSlider.value = 4;
        }
      }
      document.querySelector("#two").value = this.value;
    };

    lowerSlider.oninput = function () {
      lowerVal = parseInt(lowerSlider.value);
      upperVal = parseInt(upperSlider.value);
      if (lowerVal > upperVal - 4) {
        upperSlider.value = lowerVal + 4;
        if (upperVal == upperSlider.max) {
          lowerSlider.value = parseInt(upperSlider.max) - 4;
        }
      }
      document.querySelector("#one").value = this.value;
    };
  }
});

function initCarousel() {
  if (typeof $("body").owlCarousel == "function") {
    $(".odul-banner--slider").owlCarousel({
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      nav: true,
      loop: true,
      items: 1,
      smartSpeed: 450,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: false,
    });

    $(".odul-image-slides").owlCarousel({
      nav: false,
      loop: true,
      dots: true,
      margin: 30,
      items: 3,
      smartSpeed: 600,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: false,
      responsive: {
        0: {
          items: 1,
          margin: 10,
          stagePadding: 33.5,
        },
        768: {
          animateOut: "fadeOut",
          animateIn: "fadeIn",
          items: 3,
          margin: 30,
        },
      },
    });
  }
}

initCarousel();

$(document).on('shopify:section:load', initCarousel);

function checkVariantAvailable(t) {
  var e = JSON.parse($("[data-product-json]").html());
  var variant =
    e.variants.filter(function (e) {
      return t.every(function (t, s) {
        return e.options[s] === t;
      });
    })[0] || null;
  return variant.available;
}

function disabledOption(option, _element, total_element = 0) {
  if (!checkVariantAvailable(option)) {
    //$(_element).attr("disabled", "disabled");
    $(_element).parent().children("label").addClass("option-disabled");
    if (total_element) {
      $(_element).parent().children("label").addClass("option-disabled-1");
    }
  } else {
    $(_element).removeAttr("disabled");
    $(_element).parent().children("label").removeClass("option-disabled");
  }
}

function setOptionProducts() {
  var data_option_seleted_2 = $('input[data-index="option2"]:checked').val();
  var data_option_seleted_1 = $('input[data-index="option1"]:checked').val();
  if (typeof data_option_seleted_2 != "undefined") {
    $('input[data-index="option2"]').each(function () {
      let option = [data_option_seleted_1, $(this).val()];
      disabledOption(option, this);
    });
    // $('input[data-index="option1"]').each(function() {
    //   let option = [$(this).val(), data_option_seleted_2];
    //   disabledOption(option, this);
    // });
  } else if (typeof data_option_seleted_1 != "undefined") {
    $('input[data-index="option1"]').each(function () {
      let option = [$(this).val()];
      disabledOption(option, this, 1);
    });
  }
}
$('.product-form .product__selectors input[type="radio"]').change(function () {
  setOptionProducts();
});
setOptionProducts();

setTimeout(function () {
  $(".selector-wrapper--fullwidth input:checked").trigger("click");
}, 300);

// var price_tax_html = '';
// var t = setInterval(function(){
//     console.log(1);
//     var i =false;
//     let tax_price_element = $('.product__title__wrapper').find('.product__price').find('.dp_detail');
//     if(tax_price_element.length){
//         price_tax_html = tax_price_element.html();
//     }
//     if(price_tax_html != ''){
//         $('.product__title__wrapper').find('.product__price').find('.dualPrice').html(price_tax_html);
//         i = true;
//     }
//     console.log(price_tax_html);
//     setTimeout(function(){
//       if(i){
//         clearInterval(t);
//       }
//     },1000)
// }, 1);

$(".product__form")
  .find('input[type="radio"]')
  .change(function () {
    $(".product__title__wrapper")
      .find(".product__price__wrap")
      .attr("style", "visibility: hidden");
    setTimeout(() => {
      $(".product__title__wrapper")
        .find(".product__price__wrap")
        .removeAttr("style");
    }, 300);
  });

$(document).ready(function () {
   $(".animal-button").on("click", function () {
    var t = $(this).closest(".block-animal--top");
    $("html, body").animate(
      {
        scrollTop: t.offset().top,
      },
      300
    );
  });
  $("body").on("click", ".css-152bbx5", function () {
    $(this).toggleClass("drop-item");
    $(".css-2qrmgs").toggleClass("show");
  });

  $(".check-stone").on("click", function (e) {
    e.preventDefault();
    var b_id = $(this).attr("data-id");

    $("#select-year, #select-month, #select-date").removeClass("error");
    var year = $("#select-year").val();
    var month = $("#select-month").val();
    var datee = $("#select-date").val();

    var error = false;
    if (!year) {
      $("#select-year").addClass("error");
      error = true;
    }
    if (!month) {
      $("#select-month").addClass("error");
      error = true;
    }
    if (!datee) {
      $("#select-date").addClass("error");
      error = true;
    }
    if (error) {
      return false;
    }

    if (b_id == "color") {
      var date = new Date(year, month - 1, datee);

      var day = date.toLocaleDateString("en-US", {
        weekday: "long",
      });
    } else {
      var date_string = year + "" + month + "" + datee;

      var day = caculateNumber(date_string);
    }

    $(".form-result__day").html(day);
  });

  $(".what-color__scroll").click(function () {
    var day = $(".form-result__day").text();
    $("html, body").animate(
      {
        scrollTop: $("#" + day).offset().top - 150,
      },
      300
    );
  });

  var video1 = $("#odul_video_1");
  var video2 = $("#odul_video_2");
  var video3 = $("#odul_video_3");
  video1.on("click", function () {
    video2[0].play();
    setTimeout(function () {
      video1.hide();
      video2.addClass("active");
    }, 300);

    setTimeout(function () {
      video3[0].play();
      setTimeout(function () {
        video2.hide();
        video3.addClass("active");
      }, 800);
      setTimeout(function () {
        $(".back-top-home").addClass("active");
      }, 11000);
    }, 10000);
  });
  var video1_sp = $("#odul_video_sp_1");
  var video2_sp = $("#odul_video_sp_2");
  var video3_sp = $("#odul_video_sp_3");
  video1_sp.on("click", function () {
    video2_sp[0].play();
    setTimeout(function () {
      video1_sp.hide();
      video2_sp.addClass("active");
    }, 300);

    setTimeout(function () {
      video3_sp[0].play();
      setTimeout(function () {
        video2_sp.hide();
        video3_sp.addClass("active");
      }, 800);
      setTimeout(function () {
        $(".back-top-home").addClass("active");
      }, 11000);
    }, 10000);
  });

  $(".account_page .account-sidebar--mobile").click(function () {
    $(".account_page .account-sidebar ul").toggleClass("visible");
  });

  // video2.on("click", function(){
  //   video2.hide();
  //   video3.show();
  //   video3[0].play();
  // })
});

function caculateNumber(number_string) {
  var sum = 0;
  [...number_string].forEach((val) => {
    sum += parseInt(val);
  });

  if (sum == 11 || sum == 22 || sum <= 9) {
    return sum;
  } else {
    return caculateNumber(sum.toString());
  }
}

function changeRestockText() {
  let el = document.querySelector('#ngc-restock .ngc__modal__inner');

  if (el) {
    el.innerHTML = el.innerHTML.replace('バリエーション', '号数');
  }
  else {
    setTimeout(changeRestockText, 500);
  }
}

changeRestockText();
